/** A readable default for the device name field; the user can change it before signing in. */
export function defaultDeviceName(): string {
  if (typeof navigator === 'undefined') return 'Device';
  const ua = navigator.userAgent;
  if (/Android/i.test(ua)) return 'Android phone';
  if (/iPhone|iPad/i.test(ua)) return 'iPhone';
  if (/Windows/i.test(ua)) return 'Windows PC';
  if (/Macintosh/i.test(ua)) return 'Mac';
  if (/Linux/i.test(ua)) return 'Linux computer';
  return 'Browser';
}

export function formatRelative(ts: number, now: number, locale: string): string {
  const diff = ts - now;
  const abs = Math.abs(diff);
  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });
  if (abs < 60_000) return rtf.format(0, 'minute');
  if (abs < 3_600_000) return rtf.format(Math.round(diff / 60_000), 'minute');
  if (abs < 86_400_000) return rtf.format(Math.round(diff / 3_600_000), 'hour');
  return rtf.format(Math.round(diff / 86_400_000), 'day');
}

export function formatDateTime(ts: number, locale: string, hour12?: boolean): string {
  return new Date(ts).toLocaleString(locale, { day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit', ...(hour12 === undefined ? {} : { hourCycle: hour12 ? 'h12' : 'h23' }) });
}
